<template>
  <div class="lab-view">
    <section class="site-hero lab-hero" :style="heroStyle">
      <div class="site-hero__inner">
        <h1>实验室介绍</h1>
        <div class="desc">
          <p v-for="(paragraph, index) in labIntro" :key="index">{{ paragraph }}</p>
        </div>
      </div>
    </section>

    <section class="page-section content-section">
      <div class="page-head">
        <div><h2>实验室成果展示<span class="some-size">(部分展示)</span></h2></div>
      </div>
      <div class="page-shell">
        <el-tabs v-model="activeTab" stretch>
          <el-tab-pane label="实验室检测仪设备展示" name="equipment">
            <div class="gallery-grid">
              <article v-for="(item, idx) in pagedLabEquipmentCards" :key="idx" class="media-card panel-card">
                <div class="media-images">
                  <img v-for="(image, index) in getEquipmentImages(item)" :key="`${item.title}-${index}`" :src="image" :alt="item.title">
                </div>
                <div class="media-body">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.text }}</p>
                </div>
              </article>
            </div>
            <div v-if="labEquipmentCards.length > pageSize" class="pagination-row">
              <el-pagination
                background
                layout="prev, pager, next"
                :current-page.sync="labEquipmentPageNo"
                :page-size="pageSize"
                :total="labEquipmentCards.length"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane label="实验室战略发展展示" name="strategy">
            <div class="card-grid strategy-grid">
              <article v-for="item in pagedLabStrategicDevelopments" :key="item.title" class="strategy-card panel-card">
                <img v-if="item.image" :src="item.image" :alt="item.title">
                <div class="media-body">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.text }}</p>
                </div>
              </article>
            </div>
            <div v-if="labStrategicDevelopments.length > pageSize" class="pagination-row">
              <el-pagination
                background
                layout="prev, pager, next"
                :current-page.sync="labStrategyPageNo"
                :page-size="pageSize"
                :total="labStrategicDevelopments.length"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>
  </div>
</template>

<script>
import { getSitePage } from "@/api/website";

const DEFAULT_LAB_INTRO = [];

export default {
  name: "LabEquipmentView",
  data() {
    return {
      activeTab: "equipment",
      labSettings: {
        bannerImage: "/assets/banner.png",
        intro: DEFAULT_LAB_INTRO
      },
      labStrategicDevelopments: [],
      labEquipmentCards: [],
      labCapabilities: [],
      labStrategyPageNo: 1,
      labEquipmentPageNo: 1,
      pageSize: 12
    };
  },
  computed: {
    labIntro() {
      return this.labSettings.intro && this.labSettings.intro.length ? this.labSettings.intro : DEFAULT_LAB_INTRO;
    },
    heroStyle() {
      const image = this.labSettings.bannerImage || "/assets/banner.png";
      return {
        "--lab-banner-image": `url("${image}")`
      };
    },
    pagedLabEquipmentCards() {
      const start = (this.labEquipmentPageNo - 1) * this.pageSize;
      return this.labEquipmentCards.slice(start, start + this.pageSize);
    },
    pagedLabStrategicDevelopments() {
      const start = (this.labStrategyPageNo - 1) * this.pageSize;
      return this.labStrategicDevelopments.slice(start, start + this.pageSize);
    }
  },
  created() {
    getSitePage("labEquipment").then((res) => {
      const data = res.data || {};
      this.labSettings = data.labSettings || this.labSettings;
      this.labStrategicDevelopments = data.labStrategicDevelopments || [];
      this.labEquipmentCards = data.labEquipmentCards || [];
      this.labCapabilities = data.labCapabilities || [];
      this.labStrategyPageNo = 1;
      this.labEquipmentPageNo = 1;
    });
  },
  methods: {
    getEquipmentImages(item) {
      if (Array.isArray(item.images) && item.images.length) {
        return item.images;
      }
      return item.image ? [item.image] : [];
    }
  }
};
</script>

<style lang="less" scoped>
.lab-hero {
  background:
    linear-gradient(90deg, rgba(3, 23, 50, 0.94) 0%, rgba(7, 55, 105, 0.74) 48%, rgba(12, 83, 146, 0.34) 100%),
    var(--lab-banner-image) center / cover no-repeat;
    
    .site-hero__inner {
      .desc {
        margin-top: 60px;
        p{
          text-indent: 40px;
              max-width: 100%;
          margin-bottom: 18px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.8;
        }
      }
    }
}

.content-section {
  background: var(--soft-blue);
  .page-head {
    .some-size {
      font-size: 15px;
      padding-left: 20px;
      color: #909399;
      font-weight: 400;
    }
  }
}

.page-shell {
  width: min(1280px, 100%);
  margin: 0 auto;

  /deep/ .el-tabs__item {
    font-size: 20px;
    font-weight: 600;
  }
}

.card-grid,
.gallery-grid,
.capability-band {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.media-card {
  overflow: hidden;
}

.strategy-card {
  overflow: hidden;
}

.strategy-card > img {
  width: 100%;
  aspect-ratio: 1 / 0.72;
  object-fit: cover;
}

.media-images {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
}

.media-images img {
  width: 100%;
  aspect-ratio: 1 / 0.72;
  object-fit: cover;
}

.media-images img:only-child {
  grid-column: 1 / -1;
}

.media-body,
.band-card {
  padding: 22px;
}

.media-body h3,
.band-card h3 {
  margin: 0 0 10px;
  font-size: 22px;
}

.media-body p,
.band-card p {
  margin: 0;
  color: var(--muted);
}

.band-card b {
  display: block;
  margin-bottom: 10px;
  color: var(--blue);
  font-size: 12px;
  text-transform: uppercase;
}

.pagination-row {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

@media (max-width: 1040px) {
  .card-grid,
  .gallery-grid,
  .capability-band {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .page-shell /deep/ .el-tabs__item {
    font-size: 15px;
  }

  .lab-hero .site-hero__inner .desc {
    margin-top: 28px;
  }

  .lab-hero .site-hero__inner .desc p {
    text-indent: 2em;
    font-size: 14px;
  }

  .media-body,
  .band-card {
    padding: 18px;
  }

  .media-body h3,
  .band-card h3 {
    font-size: 20px;
  }

  .media-body p,
  .band-card p {
    font-size: 14px;
  }
}
</style>
